import s from "./CdrLink.vue2.mjs";
import o from "./styles/CdrLink.module.scss.mjs";
import t from "../../../_virtual/_plugin-vue_export-helper.mjs";
const r = {
  $style: o
}, f = /* @__PURE__ */ t(s, [["__cssModules", r]]);
export {
  f as default
};
